import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimal%20gradient%20background%20with%20soft%20coral%20and%20orange%20ambient%20light%2C%20smooth%20flowing%20abstract%20shapes%2C%20clean%20modern%20atmosphere%2C%20gentle%20warm%20glow%2C%20subtle%20texture%2C%20inviting%20and%20professional%20mood%2C%20digital%20communication%20theme%2C%20soft%20focus%20background%2C%20ethereal%20quality&width=1600&height=600&seq=cta-bg-aiqingdao-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-900/90 via-secondary-900/70 to-secondary-900/90"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-secondary-50 mb-4">
          收藏本站，路线不迷路
        </h2>
        <p className="text-secondary-200 text-base mb-8 leading-relaxed">
          我们持续更新爱情岛一论坛最新免费路线，确保你能随时稳定访问。
          现在就浏览最新路线和教程，开启你的论坛之旅。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/latest-routes"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-road-map-line text-lg"></i>
            查看最新路线
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-secondary-400/40 text-secondary-100 font-semibold text-base hover:bg-secondary-100/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}